import {api} from "../http/apiClient"

const ApiGeneral = () => {
  const sendDigitalMoments = (slug, params) => {
    return api.get(`/digital-moments/${slug}`, {params})
  }

  return { sendDigitalMoments }
}

export default ApiGeneral
